// Change this
const module_sa = 'super-admin'

import {checkAuth} from "@/services/auth";

// Change this
import Index from '@/views/settings/super-admin/Index'
import Create from '@/views/settings/super-admin/Create'
import Edit from '@/views/settings/super-admin/Edit'

var prefix = '/settings/'

export default [
    {
        path: prefix+`${module_sa}/`,
        name: `${module_sa}Index`,
        component: Index,
        beforeEnter (to,from,next){
            checkAuth().then( response =>{
                    if(response){
                        next();
                    }else{
                        next('/login');
                    }
                }

            )
        }
    },
    {
        path: prefix+`${module_sa}/create`,
        name: `${module_sa}Create`,
        component: Create,
        beforeEnter (to,from,next){
            checkAuth().then( response =>{
                    if(response){
                        next();
                    }else{
                        next('/login');
                    }
                }

            )
        }
    },
    {
        path: prefix+`${module_sa}/edit/:id`,
        name: `${module_sa}Edit`,
        component: Edit,
        beforeEnter (to,from,next){
            checkAuth().then( response =>{
                    if(response){
                        next();
                    }else{
                        next('/login');
                    }
                }

            )
        }
    },
]
